import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Badge, Paper, Tab, Tabs, Typography, makeStyles } from "@material-ui/core";
import SettingsOutlined from "@material-ui/icons/SettingsOutlined";
import SyncAlt from "@material-ui/icons/SyncAlt";
import MailOutline from "@material-ui/icons/MailOutline";
import BusinessOutlined from "@material-ui/icons/BusinessOutlined";
import Tune from "@material-ui/icons/Tune";
import { AuthContext } from "../../context/Auth/AuthContext";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import Connections from "../Connections";
import EmailAccounts from "../EmailAccounts";
import SaasPlatform from "../Saas/Platform";
import GeneralSettings from "./General";

const useStyles = makeStyles(theme => ({
  root: { height: "100%", minHeight: 0, minWidth: 0, display: "flex", flexDirection: "column" },
  header: { display: "flex", alignItems: "center", gap: 8, padding: "8px 12px 12px", flexShrink: 0 },
  tabs: {
    flexShrink: 0, borderBottom: "1px solid " + theme.palette.divider,
    "& .MuiTabs-root": { minHeight: 48 },
    "& .MuiTab-root": { minHeight: 48, minWidth: 82, textTransform: "none", fontWeight: 600, padding: "8px 12px" },
    "& .MuiTab-wrapper": { flexDirection: "row", gap: 8, whiteSpace: "nowrap" },
    "& .MuiTab-wrapper > *:first-child": { marginBottom: "0 !important" },
    "& .MuiTab-wrapper svg": { fontSize: 20 },
    [theme.breakpoints.down("sm")]: { "& .MuiTab-root": { minWidth: 64, fontSize: 11.5, padding: "8px 6px" }, "& .MuiTab-wrapper": { gap: 4 }, "& .MuiTab-wrapper svg": { fontSize: 18 } }
  },
  content: { flex: 1, minHeight: 0, minWidth: 0, overflow: "hidden" },
  panel: { height: "100%", minHeight: 0, minWidth: 0, display: "flex", flexDirection: "column", overflowY: "auto", "&[hidden]": { display: "none" } }
}));
const sections = [
  { id: "connections", label: "Conexões", icon: SyncAlt, component: Connections },
  { id: "email", label: "E-mail", icon: MailOutline, component: EmailAccounts, admin: true },
  { id: "saas", label: "SaaS", icon: BusinessOutlined, component: SaasPlatform, platform: true },
  { id: "general", label: "Geral", icon: Tune, component: GeneralSettings, admin: true }
];
const Settings = () => {
  const classes = useStyles(), history = useHistory(), location = useLocation();
  const { user } = useContext(AuthContext);
  const { whatsApps = [] } = useContext(WhatsAppsContext);
  const allowed = sections.filter(section => (!section.admin || user.profile === "admin") && (!section.platform || (user.profile === "admin" && user.isPlatformAdmin)));
  const requested = location.pathname.split("/").filter(Boolean)[1]?.toLowerCase();
  const selected = allowed.some(section => section.id === requested) ? requested : "connections";
  const [visited, setVisited] = useState(() => [selected]);
  useEffect(() => { setVisited(previous => previous.includes(selected) ? previous : [...previous, selected]); }, [selected]);
  useEffect(() => { if (requested !== selected) history.replace("/settings/" + selected); }, [requested, selected, history]);
  const warning = whatsApps.some(account => ["qrcode", "PAIRING", "DISCONNECTED", "TIMEOUT", "OPENING"].includes(account.status));
  return <div className={classes.root}>
    <div className={classes.header}><SettingsOutlined color="primary" /><Typography component="h1" variant="h6">Configurações</Typography></div>
    <Paper square elevation={0} className={classes.tabs}>
      <Tabs value={selected} onChange={(_event, value) => history.push("/settings/" + value)} variant="scrollable" scrollButtons="auto" indicatorColor="primary" textColor="primary" aria-label="Seções de configurações">
        {allowed.map(section => { const Icon = section.icon; return <Tab key={section.id} value={section.id} id={"settings-tab-" + section.id} aria-controls={"settings-panel-" + section.id} label={section.label} icon={section.id === "connections" ? <Badge variant="dot" color="error" invisible={!warning}><Icon /></Badge> : <Icon />} />; })}
      </Tabs>
    </Paper>
    <div className={classes.content}>
      {allowed.filter(section => section.id === selected || visited.includes(section.id)).map(section => { const Component = section.component; return <div key={section.id} role="tabpanel" id={"settings-panel-" + section.id} aria-labelledby={"settings-tab-" + section.id} hidden={section.id !== selected} className={classes.panel}><Component /></div>; })}
    </div>
  </div>;
};
export default Settings;
